<template>
    <LoginContainer :buttons="button" :errorMessage="errorMessage" :goToRoutes="goToRoute" :logo="logo"
        :formHidden="formHidden" @submit="SendPassResetEmail" :title="$t('questions.forgotPassword')">
        <template #form>
            <InputContent v-if="!formHidden" name="email" :label="$t('email')" placeholder="" v-model="email"
                type="email" />
            <p class="success" v-if="emailSent">{{ emailSent }}</p>
        </template>
    </LoginContainer>
</template>

<script>
import LoginContainer from '@/components/login/Login.vue';
import devLogo from "@/assets/logos/dev-logo.png"
import InputContent from '@/components/inputs/Content.vue';

export default {
    name: 'RecoverView',
    components: {
        LoginContainer,
        InputContent,
    },
    data() {
        return {
            email: '',
            errorMessage: '',
            emailSent: '',
            formHidden: false,
            goToRoute: [
                {
                    route: '/',
                    text: 'Entrar'
                },
            ],
            button: [
                {
                    text: 'Enviar Email',
                    type: 'submit',
                }
            ],
        }
    },
    methods: {
        async SendPassResetEmail() {
            this.$store.dispatch('users/recover', this.email)
            this.emailSent = `Um email para alterar a sua ${this.$t('password')} foi enviado. Verifique a sua caixa de ${this.$t('email')}.`
            this.formHidden = true
        }
    },
    computed: {
        logo() {
            if (this.$store.state.instance.logo == null) {
                return devLogo
            }
            return this.$store.state.instance.logo
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.success {
    margin-left: 10px;
    color: var(--success-color);
    font-weight: bold;
}

.link {
    margin-left: 10px;

    &:visited {
        color: var(--text-color);
        text-decoration: none;
    }

    &:link {
        text-decoration: none;
    }
}
</style>
